import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SETTING_KEY_FOR_CURRENCY_DEDUCTION } from 'src/app/shared/constants';


@Component({
  selector: 'discount-calculator',
  templateUrl: './discount-calculator.component.html',
  styleUrls: ['./discount-calculator.component.scss']
})
export class DiscountCalculatorComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    let newValue = changes["discountAmount"];
    if (newValue.currentValue != newValue.previousValue) {

      if (this.cmpDiscountValue != null && this.cmpDiscountValue != undefined && this.cmpDiscountValue != 0
          && this.cmpDiscountValueBy != null && this.cmpDiscountValueBy != undefined && this.cmpDiscountValueBy != ''
      ) {
        this.amount = this.cmpDiscountValue;
        this.discountBy = this.cmpDiscountValueBy;
        this.discountComment = this.discountComments;
        this.applyDiscount();
      }

      /* (OLD LOGIC UPDATED WITH NEW LOGIC - DT 17/05/2024)
      if (this.discountAmount != 0 && this.discountAmount != undefined) {

        if (this.discountBy == '%')
          this.amount = Math.floor((this.discountAmount / this.price) * 100) + "";
        else
          this.amount = this.discountAmount + "";
        this.discountComment = this.discountComments;
        this.applyDiscount();
      }
      */
    }
  }

  @Input() price = 15;
  @Input() currentShipment : any;
  @Input() accountCurrencyCode;
  @Input() receiptType;
  @Input() cmpDiscountValue;
  @Input() cmpDiscountValueBy;
  amount = '0'
  discount = 0;
  @Input() discountAmount = null;
  @Input() discountComments = null;

  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  @Output() appliedDiscount = new EventEmitter();
  requiredComment: string = '';
  maxAllowedDiscount = JSON.parse(sessionStorage.getItem('user')).Settings.MaximumDiscountPercentageInbound * 100;
  discountBy = '%';
  EnableCurrencyDeduction = false;

  constructor(private translate: TranslateService) {
    this.discount = this.maxAllowedDiscount;
    const setting = JSON.parse(sessionStorage.getItem('branchSettings')).find(m => m.Key == SETTING_KEY_FOR_CURRENCY_DEDUCTION);
    this.EnableCurrencyDeduction = setting != undefined ? setting.Value == 'True' : false;
  }

  getDiscountAmount() {
    var calculatedDiscountPrice = this.calculateDiscount();
    if (calculatedDiscountPrice !== 'Invalid discount!') {
      calculatedDiscountPrice = parseFloat(this.calculateDiscount());
      return (this.price - calculatedDiscountPrice);
    }
    return 0;
  }
  validDiscount = false;
  calculateDiscount() {
    if (parseFloat(this.amount) <= this.fixDecimals(this.discount) && parseFloat(this.amount) >= 0) {
      if (this.discountBy == '%') {
        this.validDiscount = true;
        return this.fixDecimals(this.price - (this.price * parseFloat(this.amount) / 100));
      }
      else {
        this.validDiscount = true;
        return this.fixDecimals(this.price - parseFloat(this.amount));
      }
    }
    else {
      this.validDiscount = false;
      return `${this.translate.instant('pages.createReceiptPage.oneReceipt.table.discountCalc.invalidDiscount')}`;
    }
  }

  getTax(RTDAfter) {
    if (this.EnableCurrencyDeduction == true && this.currentShipment.ProductGroup == "EXP") {
      return parseFloat(this.currentShipment.TaxAmount.Value);
    }

    return RTDAfter * this.currentShipment.ShipperAccountTaxRate;
  }

  calculateTotalAfterDiscount(){
    if (parseFloat(this.amount) <= this.fixDecimals(this.discount) && parseFloat(this.amount) >= 0) {
      if (this.discountBy == '%') {
        this.validDiscount = true;
        var RTDAfter = (this.price - (this.price * parseFloat(this.amount) / 100));
        return this.fixDecimals(RTDAfter + this.getTax(RTDAfter));
      }
      else {  
        this.validDiscount = true;
        var RTDAfter = this.price - parseFloat(this.amount);
        return this.fixDecimals( RTDAfter + this.getTax(RTDAfter));
      }
    }
    else {
      this.validDiscount = false;
      return 'Invalid discount!';
    }
  }

  makeDiscountBy(discountType) {
    this.discountBy = discountType;
    if (this.discountBy != '%')
      this.discount = this.price * this.maxAllowedDiscount / 100;
    else
      this.discount = this.maxAllowedDiscount;
  }
  opened = false;
  openClaculater(event: any) {
    this.opened = !this.opened;
    event.stopPropagation()
  }
  discountComment = '';
  applyDiscount() {
  
    if (this.discountComment == '') {
      this.validDiscount = false;
      this.requiredComment = `${this.translate.instant('pages.createReceiptPage.oneReceipt.table.discountCalc.commentRequired')}`;
    }
    else {
      this.requiredComment = '';
      this.validDiscount = true;
    }
    
    if (this.validDiscount) {
      
      this.appliedDiscount.emit({ 
        Amount: this.calculateTotalAfterDiscount(),
        currency: this.accountCurrencyCode, 
        DiscountAmount: this.getDiscountAmount(), 
        DiscountComments: this.discountComment,
        DiscountValue: this.amount,
        DiscountValueBy: this.discountBy
      })
      this.opened = false;
    }
  }

  ngOnInit() {
    switch(this.receiptType) {
      case 'outbound':
      case 'dropoff':
        this.maxAllowedDiscount = JSON.parse(sessionStorage.getItem('user')).Settings.MaximumDiscountPercentageOutbound * 100;
        this.discount = this.maxAllowedDiscount;
        break;

      default:
        this.discount = this.maxAllowedDiscount;
        break;
    }
  }


  fixDecimals(value: any = 0) {
    if (value != 0 && value != null) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      if (value || value == 0)
        return '0.00';
      else
        return '';
    }
  }


}
